<div class="auth-container">
    <div class="auth-card">
        <div class="auth-header">
            <h2>Forgot Password</h2>
            <p>Enter your email to reset your password</p>
        </div>

        <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="email">Email</label>
                <input id="email" type="email" formControlName="email" placeholder="Enter your email"
                    [class.invalid]="forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched">
            </div>

            <button type="submit" [disabled]="forgotForm.invalid || isLoading" class="btn-primary">
                <span *ngIf="!isLoading">Send Reset Link</span>
                <span *ngIf="isLoading">Sending...</span>
            </button>

            <div *ngIf="message" [class.success-alert]="isSuccess" [class.error-alert]="!isSuccess">
                {{ message }}
            </div>
        </form>

        <div class="auth-footer">
            <p>Remembered your password? <a routerLink="/login">Sign in</a></p>
        </div>
    </div>
</div>